import React from 'react';
import { InvitationSamlSso } from '@hotjar/webapp/features/Activation/InvitationSamlSso';
import { useTranslation } from 'react-i18next';
import { useQueryParameter } from '@hotjar/webapp/hooks/useQueryParameter';

export type IdentityProviderDetails =
  | {
      displayName: string;
      id: string;
    }
  | undefined;

interface SAMLSSOFormProps {
  hasLoaded: boolean;
  identityProviderDetails: IdentityProviderDetails;
  email: string;
  organizationName: string;
}

export const SAMLSSOForm = ({
  hasLoaded,
  identityProviderDetails,
  email,
  organizationName,
}: SAMLSSOFormProps): JSX.Element => {
  const { t } = useTranslation();

  const tokenQueryParam = useQueryParameter('token');

  return (
    /*
        @TODO Migrate SCSS styles to Design System
        The following form / page styles come from 'login_register.scss', which should be
        eventually replaced with Design System (or the custom styles, defined within
        React Component via 'emotion/styled' API)
      */
    <div data-testid="saml-sso" className="loggedout-form-page">
      <div id="signup-header" className="transition-200 no-back">
        <div className="login-logo" />
      </div>

      {hasLoaded && identityProviderDetails && (
        <div className="join-team-form">
          <div className="content-inner">
            <div className="section-content">
              <div className="join-team-container">
                <div>
                  <InvitationSamlSso
                    email={email}
                    organizationName={organizationName}
                    invitationToken={tokenQueryParam || ''}
                    identityProvider={identityProviderDetails}
                  />
                </div>
              </div>
              <div className="col-image center transition-200 blue">
                <span>
                  <div className="img-container img-heatmap">
                    <img alt="" src="~@hotjar/shared-assets/images/signup/2.png" />
                  </div>
                  <div className="foot-note">
                    <h3>{t('common:registration.join-team.identity-provider.title')}</h3>
                    <span className="font16 light">
                      {t('common:registration.join-team.identity-provider.subtitle')}
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
